import * as React from 'react';
import { startLoadingPilets } from 'piral-base';
import { useAction } from '../hooks';
import { none } from '../utils';
/**
 * The Mediator component for interfacing with pilets loading.
 */
export const Mediator = ({ options }) => {
    const initialize = useAction('initialize');
    React.useEffect(() => {
        const { connect, disconnect } = startLoadingPilets(options);
        const notifier = (error, pilets, loaded) => {
            initialize(!loaded, error, pilets);
        };
        connect(notifier);
        return () => disconnect(notifier);
    }, none);
    // tslint:disable-next-line:no-null-keyword
    return null;
};
//# sourceMappingURL=Mediator.js.map